// This file is generated by pnpm icons:generate. Do not edit.

import {BellRinging_Filled_Corner0_Rounded as CanonicalBellRinging_Filled_Corner0_Rounded} from './Bell'
import {BellRinging_Stroke2_Corner0_Rounded as CanonicalBellRinging_Stroke2_Corner0_Rounded} from './Bell'

/** @deprecated Import BellRinging_Filled_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const BellRinging_Filled_Corner0_Rounded =
  CanonicalBellRinging_Filled_Corner0_Rounded

/** @deprecated Import BellRinging_Stroke2_Corner0_Rounded from `#/components/icons/Bell` instead. */
export const BellRinging_Stroke2_Corner0_Rounded =
  CanonicalBellRinging_Stroke2_Corner0_Rounded
